import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { reservationApi } from '../api/reservationApi';
import { setSEO } from '../utils/seo';

const ExtensionPaymentSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setSEO('extensionPaymentSuccess');

    const processPayment = async () => {
      try {
        const paymentKey = searchParams.get('paymentKey');
        const orderId = searchParams.get('orderId');
        const amount = searchParams.get('amount');
        const reservationId = searchParams.get('reservationId');
        const newEndDate = searchParams.get('newEndDate');

        if (!paymentKey || !orderId || !amount || !reservationId || !newEndDate) {
          throw new Error('필수 파라미터가 누락되었습니다.');
        }

        // 예약 연장 API 호출
        await reservationApi.extendReservation(
          parseInt(reservationId),
          newEndDate,
          paymentKey,
          orderId,
          parseInt(amount)
        );

        setIsProcessing(false);

        // 3초 후 예약 상세 페이지로 이동
        setTimeout(() => {
          navigate('/my-reservations');
        }, 3000);
      } catch (err: any) {
        console.error('예약 연장 처리 실패:', err);
        setError(err.response?.data?.detail || '예약 연장 처리 중 오류가 발생했습니다.');
        setIsProcessing(false);
      }
    };

    processPayment();
  }, [searchParams, navigate]);

  if (isProcessing) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">예약 연장 처리 중</h2>
          <p className="text-gray-600">결제 확인 및 예약 연장을 처리하고 있습니다...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
          <div className="text-red-500 text-6xl mb-4">✕</div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">예약 연장 실패</h2>
          <p className="text-gray-600 mb-6">{error}</p>
          <button
            onClick={() => navigate('/my-reservations')}
            className="bg-blue-600 text-white py-2 px-6 rounded-md hover:bg-blue-700 transition-colors"
          >
            내 예약 목록으로
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
        <div className="text-green-500 text-6xl mb-4">✓</div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">예약 연장 완료!</h2>
        <p className="text-gray-600 mb-6">
          결제가 완료되어 예약이 성공적으로 연장되었습니다.
        </p>
        <p className="text-sm text-gray-500 mb-6">3초 후 내 예약 목록으로 이동합니다...</p>
        <button
          onClick={() => navigate('/my-reservations')}
          className="bg-blue-600 text-white py-2 px-6 rounded-md hover:bg-blue-700 transition-colors"
        >
          내 예약 목록으로
        </button>
      </div>
    </div>
  );
};

export default ExtensionPaymentSuccessPage;
